import { render, staticRenderFns } from "./MenuDrawer.vue?vue&type=template&id=3faaa856&scoped=true"
import script from "./MenuDrawer.vue?vue&type=script&lang=ts"
export * from "./MenuDrawer.vue?vue&type=script&lang=ts"
import style0 from "./MenuDrawer.vue?vue&type=style&index=0&id=3faaa856&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faaa856",
  null
  
)

export default component.exports